import HomePage from './components/HomePage/HomePage';
import Contact from './components/Contact/Contact';
import Thesis from './components/Thesis/Thesis';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import { useEffect, useState } from 'react';

// New EE specific components (placeholders will be created)
import WorkExperience from './components/Career/Career'; // This is your main Career page
import PCBDesign from './components/PCBDesign/PCBDesign';
import OtherEEProjects from './components/OtherEEProjects/OtherEEProjects'; // Renamed component
// Keep original Career component if it's an overview page, distinct from WorkExperience
// import CareerOverview from './components/Career/Career'; // Removing this if not distinct

function App() {
    const [isDark, setIsDark] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            const transitionDiv = document.querySelector('.transition-effect');
            const careerDiv = document.querySelector('.career-container');
    
            if (!transitionDiv || !careerDiv) {
                return;
            }
    
            const careerOffsetTop = careerDiv.offsetTop;
            const scrollPosition = window.pageYOffset + window.innerHeight;
    
            if (scrollPosition >= careerOffsetTop) {
                transitionDiv.classList.add('animate');
            } else {
                transitionDiv.classList.remove('animate');
            }
        };
    
        window.addEventListener('scroll', handleScroll);
        // Init theme state from DOM (set by public/index.html script)
        try {
            const root = document.documentElement;
            setIsDark(root.classList.contains('dark'));
        } catch (e) {}

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    
    return (
        <Router>
            <div className="nav-container">
                <header>
                    <nav className="nav-bar">
                        <ul className="menu">
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/work-experience">Career</Link></li> {/* Changed to direct link */}
                            <li>
                            </li>
                            <li><Link to="/thesis">MSEE Thesis</Link></li>
                            <li><Link to="/contact">Contact Me</Link></li>
                        </ul>
                        <div className="toolbar-right">
                          <button
                            type="button"
                            aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
                            onClick={() => {
                              const root = document.documentElement;
                              const next = !root.classList.contains('dark');
                              if (next) { root.classList.add('dark'); localStorage.setItem('theme','dark'); }
                              else { root.classList.remove('dark'); localStorage.setItem('theme','light'); }
                              setIsDark(next);
                            }}
                            className="theme-toggle"
                          >
                            {isDark ? 'Dark' : 'Light'}
                          </button>
                        </div>
                    </nav>
                </header>

                <main id="main">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/work-experience" element={<WorkExperience />} />
                        {/* <Route path="/career-overview" element={<CareerOverview />} /> Removed */}
                        <Route path="/pcb-design" element={<PCBDesign />} />
                        <Route path="/other-ee-projects" element={<OtherEEProjects />} />
                        <Route path ="/thesis" element={<Thesis />} />
                        {/* Routes for old software projects - decide if/where to keep them
                        <Route path ="/spotify-weather" element={<SpotifyWeather />} />
                        <Route path="/bill-split" element={<BillSplit />} />
                        */}
                        <Route path="/contact" element={<Contact />} />
                    </Routes>
                </main>
            </div>
        </Router>
    );
}

export default App;
